exports = module.exports = require("./../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".noData{background-color:#ffcb8b;margin-top:15px;border:1px solid #c76b00}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/stylus-loader!./src/app/components/noData/noData.styl
// module id = 784
// module chunks = 0